var _ellipse, _circle, _path, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 8.5,
    rx: 3.5,
    ry: 3.5,
    fill: "#5FD0FB",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.00156,
    cy: 9.00156,
    r: 7.97143,
    stroke: "#B5B5B7",
    strokeWidth: 0.857143
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20312 5.4L7.28551 5.3245C8.47949 4.23021 10.4043 4.72506 10.9225 6.25951V6.25951V6.25951C11.1938 7.22784 10.6745 8.24192 9.73022 8.58778L8.2806 9.11873V10.2",
    stroke: "#B5B5B7",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.28022,
    cy: 12.4365,
    rx: 0.834903,
    ry: 0.834903,
    fill: "#B5B5B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpMark);
export default __webpack_public_path__ + "static/media/help-mark.6b9506466daa06a33c1c5d874fb60bfc.svg";
export { ForwardRef as ReactComponent };